import React from 'react';
type Variant = 'primary' | 'outline-dark' | 'outline-light';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: React.ReactNode;
}
const variants: Record<Variant, string> = {
  primary: 'bg-brand-blue text-black hover:bg-brand-bluehover',
  'outline-dark': 'border border-white/25 text-white hover:bg-white hover:text-black',
  'outline-light': 'border border-black/20 text-black hover:bg-black hover:text-white'
};
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`inline-flex items-center justify-center px-7 py-3.5 font-mono-eyebrow text-xs font-semibold uppercase tracking-[0.15em] transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2 ${variants[variant]} ${className}`} {...props} data-id="element-8" data-mp="289wcb6oui6vr">
      {children}
    </button>;
}